import Vue from 'vue';
import Vuex from 'vuex';


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
  },
  state: {
    user: null,
    signedIn: false,
    api_url: 'https://hgogjz2lrh.execute-api.us-west-2.amazonaws.com/api/'
  },
  mutations:{
    setSignIn: function(state, user){
      state.user = user;
      state.signedIn = true;
    },  
    setSignOut: function(state){
      state.user = null; 
      state.signedIn = false;
    }
  }
});
